import React from 'react';
import { css } from '@emotion/react';
import { BirdiTheme } from '@birdi/theme';

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({
  currentStep,
  totalSteps,
}) => {
  const percentage = (currentStep / totalSteps) * 100;

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        gap: 0.5rem;
        width: 100%;
      `}
    >
      <div
        css={css`
          display: flex;
          justify-content: space-between;
          align-items: center;
        `}
      >
        <span
          css={(theme: BirdiTheme) => css`
            font-size: 0.875rem;
            font-weight: 500;
            color: ${theme.mono70};
          `}
        >
          Step {currentStep} of {totalSteps}
        </span>
        <span
          css={(theme: BirdiTheme) => css`
            font-size: 0.875rem;
            font-weight: 500;
            color: ${theme.mono60};
          `}
        >
          {Math.round(percentage)}% Complete
        </span>
      </div>
      <div
        css={(theme: BirdiTheme) => css`
          width: 100%;
          height: 0.5rem;
          background-color: ${theme.mono20};
          border-radius: 0.25rem;
          overflow: hidden;
        `}
      >
        <div
          css={(theme: BirdiTheme) => css`
            height: 100%;
            width: ${percentage}%;
            background-color: ${theme.ocean};
            border-radius: 0.25rem;
            transition: width 0.3s ease;
          `}
        />
      </div>
    </div>
  );
};

